import { ComponentMap } from '@cinch-nx/data-storyblok'
import { FinanceOffersCarouselBlock } from '../organism-blocks'

export const organismStoryblokComponents: ComponentMap = {
  FinanceOffersCarousel: FinanceOffersCarouselBlock,
}
